module.exports = "/_next/static/images/46ad59c165a9500cd96d6963c7b7b91e-nubanker-pm@2x.jpg.webp";